import { createDataSelectors } from "@app/modules/app.reducers";
import { WorkItem } from "@ea/shared_types/types";

export const workItemDataSelectors = createDataSelectors<WorkItem>()("workItems");
